import { AnyAction } from "redux";
import { SET_EDIT_USER_DETAILS_LOADED } from "../actions/loadingEditUserDetails";

export const loadingEditUserDetails = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_EDIT_USER_DETAILS_LOADED:
      return action.editUserDetailsLoaded;
    default:
      return state;
  }
};

export default loadingEditUserDetails;
